/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Glyph } from 'kepler';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateBreadcrumb } from '../actions/action-breadcrumb';
import { TOPIC } from '../constants/PropTypesShapes';
import Page from '../../lib/page';
import getHistory from '../../lib/HistoryHelper';
import i18n from '../../lib/reacti18n';
import { trackLink } from '../../lib/analytics-helper';

const exp = Page.getUserExperience();
const title = i18n.message(`smarthelp/contentToggle.content.label.desktop.${exp}`);
const history = getHistory();
const home = `/${exp}/home`;
const topicPath = `/${exp}/topic`;

class AccordionTopic extends Component {

  constructor(props) {
    super(props);
    this.state = { expanded: props.expanded };
    this.toggle = this.toggle.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  componentWillReceiveProps(props) {
    this.setState({
      expanded: props.expanded,
    });
  }

  componentDidUpdate() {
    if (this.contentElement && this.state.expanded) {
      this.contentElement.scrollIntoView(true);
      Page.scrollDown();
    }
  }

  toggle() {
    this.setState((prevState) => {
      const expanded = !prevState.expanded;
      const topic = this.props.topic;
      this.props.onToggle(topic, expanded);
      return { expanded };
    });
  }

  // Handle Key press for accessing the subTopics in the L2 topics
  handleKeyPress(event) {
    if (event.which === 13) {
      this.toggle();
    }
  }

  // Handle Key Press for click articles in the topics list
  handleArticleKeyPress(event, article, parentTopics, subTopics) {
    if (event.which === 13) {
      this.goToArticle(article, parentTopics, subTopics);
    }
  }

  goToArticle(article, parentTopics, subTopics) {
    const items = [];
    if (!Page.isMobileLayout()) {
      items.push({
        title,
        path: home,
        id: parentTopics.id,
      }, {
        title: parentTopics.articleTitle,
        path: `${topicPath}/${parentTopics.id}`,
        id: parentTopics.id,
      }, {
        title: subTopics.name,
        path: `${topicPath}/${parentTopics.id}`,
        id: subTopics.id,
      });
    } else {
      items.push({
        title: subTopics.name,
        path: `${topicPath}/${parentTopics.id}`,
        id: subTopics.id,
      });
    }
    this.props.updateBreadcrumb(items);
    trackLink({ id: 'articlePage', link: `smarthelp-article-page|${exp}|${article.articleId}` });
    history.push(`/${exp}/article/${Page.getFormattedUrlForArticle(article.articleTitle, article.articleId)}`);
  }

  renderAccordionContent(articleList, parentTopics) {
    const subTopics = {
      id: articleList.id,
      name: articleList.name,
    };
    const listItems = articleList.faqList.map(article =>
      <li
        key={article.articleId}
        tabIndex="0"
        onClick={() => this.goToArticle(article, parentTopics, subTopics)}
        onKeyPress={event => this.handleArticleKeyPress(event, article, parentTopics, subTopics)}
      >
        {article.articleTitle}
      </li>,
    );
    return <ul>{listItems}</ul>;
  }

  render() {
    const classAccordionContent = classNames({
      'accordion-contents': true,
      open: this.state.expanded,
    });

    const accordionIcon = classNames({
      'icon-arrow-up-small': this.state.expanded,
      'icon-arrow-down-small': !this.state.expanded,
    });

    const { topic, parent } = this.props;
    return (
      <div className="accordion-topic-container">
        <div className="title-container">
          <div // eslint-disable-line jsx-a11y/no-static-element-interactions
            className="title topic-level2"
            role="button"
            tabIndex="0"
            onClick={() => this.toggle()}
            onKeyPress={event => this.handleKeyPress(event)}
          >
            <div className="title-label" ref={(el) => { this.contentElement = el; }}> {topic.name} </div>
            <Glyph icon={accordionIcon} className="accordion-icon" />
          </div>
        </div>
        <div className={classAccordionContent}>
          {this.renderAccordionContent(topic, parent)}
        </div>
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ updateBreadcrumb }, dispatch);
}

AccordionTopic.propTypes = {
  expanded: PropTypes.bool.isRequired,
  topic: PropTypes.shape(TOPIC).isRequired,
  onToggle: PropTypes.func.isRequired,
  updateBreadcrumb: PropTypes.func.isRequired,
  parent: PropTypes.shape({
    id: PropTypes.string,
    articleTitle: PropTypes.string,
  }).isRequired,
};

export default connect(null, mapDispatchToProps)(AccordionTopic);



// WEBPACK FOOTER //
// ./home/components/AccordionTopic.js